<template>
  <div class="password-box">
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="11"
        placeholder="请输入手机号"
        v-model="loginForm.mobile"
        clearable
      ></el-input>
    </div>
    <div class="input">
      <el-input
        class="btn-form"
        placeholder="请输入密码"
        v-model="loginForm.pwd"
        show-password
        clearable
      ></el-input>
    </div>
    <div class="viewDetail">
      我已阅读并同意 <secrect-control></secrect-control>
    </div>
    <div class="verification" @click="showYanzm()">
      <i
        :class="{ iconfont: true, iconyuandian: true, pad: role == 2 }"
        v-if="!loginForm.randomStr"
      ></i>
      <i
        :class="{ iconfont: true, iconwancheng: true, pad: role == 2 }"
        v-if="loginForm.randomStr"
      ></i>
      <div>点击按钮进行验证</div>
    </div>
    <div class="btns">
      <el-button type="primary" @click="loginHandler()" :loading="loginDisable">
        <span v-if="loginDisable">登录中</span>
        <span v-if="!loginDisable">登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { LOGIN_API,REPORT_API } from "@/api.js";
import { isMobile } from '@/untils/validate'
import SecrectControl from '@/components/secrect'
export default {
  props: ['role'],
  data() {
    return {
      loginForm: {
        mobile: '',
        pwd: '',
        randomStr: '',
        ticket: '',
      },
      loginDisable: false,
      loginTitle: ['学生刷题登录', '学生刷题注册', '学生刷题找回密码'],
    }
  },
  components:{
    SecrectControl
  },
  methods: {
    callback(res) {
      console.log(res)
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res && res.ret === 0) {
        this.loginForm.randomStr = res.randstr
        this.loginForm.ticket = res.ticket
      }
    },
    showYanzm() {
      if (!isMobile(this.loginForm.mobile)) {
        this.$message.error('亲，手机号格式不正确，请重试！')
        return
      }
      var captcha1 = new TencentCaptcha('2012913766', this.callback)
      captcha1.show()
    },
    loginHandler() {
      if (!this.loginForm.mobile || !this.loginForm.pwd) {
        this.$message.error('请输入手机号、密码！')
        return
      }
      if (!this.loginForm.randomStr || !this.loginForm.ticket) {
        this.$message.error('亲，请先完成拼图验证！')
        return
      }
      this.loginDisable = true
      if (this.role == '1') {
        // for c
        this.$axios
          .post(
            `${LOGIN_API}/customer/api/userLogin`,
            this.loginForm
          )
          .then((res) => {
            if (res.data.errno == 0) {
              if (res.data.result) {
                this.$message.success('登录成功！')
                this.$cookies.set(
                  'client_token',
                  JSON.stringify({
                    token: res.data.result,
                    mobile: this.loginForm.mobile,
                  }),
                  0
                  // 60 * 60 * 12
                )
                this.$axios.defaults.headers.common['authorization'] =
                  res.data.result
                this.$store.dispatch('setLogin', true)
                this.$emit('close')
                location.reload()
              }
            } else {
              this.loginForm.randomStr = ''
              this.loginForm.ticket = ''
              this.$message.error(res.data.errmsg)
            }
            this.loginDisable = false
          })
      } else {
        // for b
        this.$axios
          .post(
            `${REPORT_API}/api/account/userLogin`,
            this.loginForm
          )
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.data) {
                if (res.data.data.finish == 0) {
                  //没有完善
                  this.$message.success('登录成功，请继续完善信息！')
                  const hr_token = JSON.stringify({
                    token: res.data.data.kao_token,
                    finish: 0,
                    mobile: this.loginForm.mobile,
                  })
                  document.cookie =
                    'hr_token=' +
                    hr_token +
                    '; max-age=' +
                    60 * 60 * 12 +
                    '; path=/;'

                  this.$router.push({
                    path: '/register/compInfo',
                    query: { backURL: this.$route.query.backURL },
                  })
                } else {
                  this.$message.success('登录成功！')
                  const hr_token = JSON.stringify({
                    token: res.data.data.kao_token,
                    finish: 1,
                    mobile: this.loginForm.mobile,
                  })
                  document.cookie =
                    'hr_token=' +
                    hr_token +
                    '; max-age=' +
                    60 * 60 * 12 +
                    '; path=/;'
                  //TODO: vue-cookie always encode cookie
                  //this.$cookies.set("kao_token", res.data.data, 60 * 60 * 12, '/', '.acmcoder.com')
                  document.cookie =
                    'kao_token="' +
                    res.data.data.kao_token +
                    '"; max-age=' +
                    60 * 60 * 12 +
                    '; path=/; domain=.acmcoder.com;'
                  if (this.$route.query.backURL) {
                    this.$router.push(this.$route.query.backURL)
                  } else {
                    location.href = 'https://kao.acmcoder.com/b/'
                  }
                }
              }
            } else {
              this.loginForm.randomStr = ''
              this.loginForm.ticket = ''
              this.$message.error(res.data.message)
            }
            this.loginDisable = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.password-box {
  width: 315px;
  margin: 20px auto 0px;
  .input {
    padding: 10px 0px;
  }
  .viewDetail{
    margin-top: 10px;
    font-size: 14px;
  }
  .verification {
    padding: 10px;
    margin: 10px 0px;
    border-radius: 5px;
    background-image: linear-gradient(#fff, #eee);
    border: 1px solid #ddd;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    .iconyuandian,.iconwancheng {
      float: left;
      padding-left: 15px;
      color: #29bdb9;
      &.pad {
        padding-top: 4px;
      }
    }
    .el-icon-success {
      float: left;
      margin: 5px 0px 0px 10px;
      color: #29bdb9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/model/login-password.vue